import React, { PropTypes } from 'react';
import LeftNav from './leftNav-partnerFinder';
import List from './list-partnerFinder';
import SendCustomMsg from './send-custom-msg';

const SearchResults = props => (
  <div className="l-app-content l-left-nav-with-content" style={{ paddingTop: '72px' }}>
    <LeftNav className="integration-left-nav l-left-nav" {...props} />
    <List {...props} />
    <SendCustomMsg
      sendInvitation={props.sendInvitation}
      onRequestClose={props.closePopover}
      updateCustomizedMsg={props.updateCustomizedMsg}
    />
  </div>
);

SearchResults.propTypes = {
  sendInvitation: PropTypes.func,
  closePopover: PropTypes.func,
  updateCustomizedMsg: PropTypes.func,
};

export default SearchResults;



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/results-partnerFinder.jsx